import { render, staticRenderFns } from "./AddSample.vue?vue&type=template&id=4e4ebaca&scoped=true"
import script from "./AddSample.vue?vue&type=script&lang=js"
export * from "./AddSample.vue?vue&type=script&lang=js"
import style0 from "./AddSample.vue?vue&type=style&index=0&id=4e4ebaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ebaca",
  null
  
)

export default component.exports